import React from 'react';
import ModalLayoutPrimary from './Modal/components/ModalLayoutPrimary/ModalLayoutPrimary';
import AppText from '../typography/AppText/AppText';
import Modal from './Modal/Modal';
import { translate } from '../../../helpers/translatioHelpers';

type Props = {
   onClose: () => void;
   text?: string;
}

const ErrorModal: React.FC<Props> = ({ onClose, text }) => {
   return (
      <Modal onClose={onClose} showClose>
         <ModalLayoutPrimary title={translate('Помилка')} >
            <AppText variant={'B500'} style={{ display: 'block', width: '100%', textAlign: 'center' }}>
               {text}
            </AppText>
         </ModalLayoutPrimary>
      </Modal>
   );
};

export default ErrorModal;
